import { blobticService } from '../../Commun/services/blobticService';

export interface Trip {
    id: number;
    uid: string;
    vehicleId: number;
    driverId: number;
    title: string;
    description?: string;
    purpose: string;
    status: string;
    startAddress?: string;
    endAddress?: string;
    scheduledStart?: Date;
    scheduledEnd?: Date;
    distance?: number;
    vehicleRegistration?: string;
    driverLicenseNumber?: string;
    lastUpdate?: Date;
    userId?: number;
}

interface TripDto {
    TRP_IDF: number;
    TRP_UIDF: string;
    VEH_IDF: number;
    DRV_IDF: number;
    TRP_TITLE: string;
    TRP_DESCRIPTION?: string;
    TRP_PURPOSE: string;
    TRP_STATUS: string;
    TRP_START_ADDRESS?: string;
    TRP_END_ADDRESS?: string;
    TRP_SCHEDULED_START?: string;
    TRP_SCHEDULED_END?: string;
    TRP_DISTANCE?: number;
    VEH_REGISTRATION?: string;
    DRV_LICENSE_NUMBER?: string;
    LAST_UPDT?: string;
    USER_IDF?: number;
}

const mapDtoToModel = (dto: TripDto): Trip => ({
    id: dto.TRP_IDF,
    uid: dto.TRP_UIDF,
    vehicleId: dto.VEH_IDF,
    driverId: dto.DRV_IDF,
    title: dto.TRP_TITLE,
    description: dto.TRP_DESCRIPTION,
    purpose: dto.TRP_PURPOSE,
    status: dto.TRP_STATUS,
    startAddress: dto.TRP_START_ADDRESS,
    endAddress: dto.TRP_END_ADDRESS,
    scheduledStart: dto.TRP_SCHEDULED_START ? new Date(dto.TRP_SCHEDULED_START) : undefined,
    scheduledEnd: dto.TRP_SCHEDULED_END ? new Date(dto.TRP_SCHEDULED_END) : undefined,
    distance: dto.TRP_DISTANCE,
    vehicleRegistration: dto.VEH_REGISTRATION,
    driverLicenseNumber: dto.DRV_LICENSE_NUMBER,
    lastUpdate: dto.LAST_UPDT ? new Date(dto.LAST_UPDT) : undefined,
    userId: dto.USER_IDF
});

export const tripsApi = {
    getAll: async () => {
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parc',
            Action: { OKey: 'Blobtic_Parc,parc_trip,Select' }
        });
        if (response.success && Array.isArray(response.data)) {
            return { data: response.data.map((item: any) => mapDtoToModel(item)), success: true };
        }
        return { data: [], success: false, message: response.message };
    },

    create: async (data: Partial<Trip>) => {
        const payload: any = {
            OKey: 'Blobtic_Parc,parc_trip,Insert',
            VEH_IDF: data.vehicleId,
            DRV_IDF: data.driverId,
            TRP_TITLE: data.title,
            TRP_DESCRIPTION: data.description,
            TRP_PURPOSE: data.purpose,
            TRP_STATUS: data.status || 'scheduled',
            TRP_START_ADDRESS: data.startAddress,
            TRP_END_ADDRESS: data.endAddress,
            TRP_SCHEDULED_START: data.scheduledStart?.toISOString(),
            TRP_SCHEDULED_END: data.scheduledEnd?.toISOString(),
            TRP_DISTANCE: data.distance
        };
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parc',
            Action: payload
        });
        return response;
    },

    update: async (id: number, data: Partial<Trip>) => {
        const payload: any = {
            OKey: 'Blobtic_Parc,parc_trip,Update',
            TRP_IDF: id,
            VEH_IDF: data.vehicleId,
            DRV_IDF: data.driverId,
            TRP_TITLE: data.title,
            TRP_DESCRIPTION: data.description,
            TRP_PURPOSE: data.purpose,
            TRP_STATUS: data.status,
            TRP_START_ADDRESS: data.startAddress,
            TRP_END_ADDRESS: data.endAddress,
            TRP_SCHEDULED_START: data.scheduledStart?.toISOString(),
            TRP_SCHEDULED_END: data.scheduledEnd?.toISOString(),
            TRP_DISTANCE: data.distance
        };
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parc',
            Action: payload
        });
        return response;
    },

    delete: async (id: number) => {
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Parc',
            Action: { OKey: 'Blobtic_Parc,parc_trip,Delete', TRP_IDF: id }
        });
        return response;
    }
};
